import { render, staticRenderFns } from "./Articulo.vue?vue&type=template&id=a7faf5ba&"
import script from "./Articulo.vue?vue&type=script&lang=js&"
export * from "./Articulo.vue?vue&type=script&lang=js&"
import style0 from "./Articulo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports